<template>
  <b-row class="p-0 p-0">
  <!-- begining of the question answer -->
  <b-col lg="12" class="p-0 m-0 ">
    <b-row class="p-0 m-0 ">
      <b-col lg="12" class="m-0 p-0 text-center">
        <div
          class="mx-auto my-5 p-4 p-md-5 rounded-4 text-white shadow-lg"
          style="background: rgba(0,0,0,0.86); max-width: 980px; text-align: justify; line-height: 1.55;"
        >
          <!-- Header -->
          <div class="d-flex align-items-center mb-4" style="gap: 1.2rem;">
            <div
              class="rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
              style="width:68px;height:68px;background:linear-gradient(135deg,#dc3545,#fd7e14);
                     box-shadow:0 8px 24px rgba(0,0,0,.35), inset 0 0 0 2px rgba(255,255,255,.15);"
            >
              <!-- warning icon -->
              <svg width="40" height="40" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                <path d="M7.938 2.016a1 1 0 0 1 1.124 0l6 4.5A1 1 0 0 1 14.999 8H1a1 1 0 0 1-.563-1.816l6-4.5z"/>
                <path d="M8 9a.905.905 0 0 0-.9.9v3.2a.9.9 0 1 0 1.8 0V9.9A.905.905 0 0 0 8 9zm0-1.5A1.1 1.1 0 1 0 8 5a1.1 1.1 0 0 0 0 2.2z"/>
              </svg>
            </div>
            <div class="flex-grow-1">
              <h2
                class="fw-bold mb-1"
                style="letter-spacing:.3px; font-size:clamp(1.8rem,2.1vw+1rem,2.5rem); line-height:1.15;"
              >
                Заявление о раскрытии информации о рисках
              </h2>
              <div class="text-white-50" style="font-size:.95rem;">
                Платформа Payton.kz / Частная компания «Digital Galaxy Ltd.»
              </div>
            </div>
          </div>

          <!-- Intro -->
          <p>
            Настоящее Заявление о раскрытии информации о рисках (далее – «Заявление») регулирует
            использование платформы <strong>payton.kz</strong>, принадлежащей Частной компании
            <strong>«Digital Galaxy Ltd.»</strong>, предназначенной для осуществления операций с цифровыми
            активами, включая веб-интерфейс и мобильные приложения (далее совместно – «Платформа»).
          </p>
          <p>
            В этом Заявлении термины «Пользователь» и «вы» обозначают одно и то же лицо — того,
            кто использует Платформу.
          </p>
          <p>
            Настоящее Заявление является неотъемлемой частью Пользовательского соглашения и
            рассматривается совместно с Политикой конфиденциальности и Политикой AML/CFT Платформы.
          </p>
          <p>
            Пользуясь Платформой, вы подтверждаете ознакомление с природой и объёмом рисков, связанных
            с операциями с цифровыми активами и использованием услуг Платформы, и осознаёте и принимаете
            на себя указанные риски. Вы осознаёте, что несёте полную ответственность за самостоятельную
            оценку целесообразности, пригодности и приемлемости таких операций с учётом ваших личных
            обстоятельств и финансовых возможностей.
          </p>
          <p>
            Частная компания <strong>«Digital Galaxy Ltd.»</strong> не предоставляет инвестиционных,
            финансовых, налоговых или юридических консультаций и не даёт каких-либо гарантий доходности
            или заверений в отношении доходности. Использование Платформы осуществляется вами
            самостоятельно на свой риск. Приведённая ниже информация не является исчерпывающей,
            и вам рекомендуется обратиться за независимой профессиональной консультацией
            до принятия любых решений.
          </p>

          <!-- 1. Общие риски -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem; line-height:1.1;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#ffc107" aria-hidden="true">
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.964 0L.165 13.233C-.12 13.72.256 14.333.804 14.333h14.392c.548 0 .924-.613.639-1.1L8.982 1.566zM8 5.5a.905.905 0 0 1 .9.9v3.2a.9.9 0 1 1-1.8 0V6.4A.905.905 0 0 1 8 5.5zm0 7.1a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2z"
                />
              </svg>
              <h5
                class="text-white-50 text-uppercase fw-semibold mb-0"
                style="letter-spacing:.5px;"
              >
                1. Общие риски, связанные с операциями с цифровыми активами
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>1.1. Отсутствие статуса законного платёжного средства.</strong>
                Цифровые активы не являются официальным (государственным) платёжным средством
                и не обеспечены государственными гарантиями или механизмами защиты.
              </li>
              <li class="mt-2">
                <strong>1.2. Высокая волатильность.</strong>
                Стоимость цифровых активов может быстро и существенно изменяться в обе стороны:
                цена может резко снизиться вплоть до полной утраты стоимости, включая стейблкоины
                в случае потери привязки к базовому активу.
              </li>
              <li class="mt-2">
                <strong>1.3. Риск полной или частичной потери вложений.</strong>
                Операции с цифровыми активами сопряжены с риском полной или частичной потери средств.
              </li>
              <li class="mt-2">
                <strong>1.4. Ограниченная ликвидность.</strong>
                Некоторые цифровые активы могут обладать низкой ликвидностью или быть неликвидными.
                В определённых рыночных условиях закрытие позиции или продажа актива
                может быть затруднена или невозможна.
              </li>
              <li class="mt-2">
                <strong>1.5. Сложность и недостаток информации.</strong>
                Оценка цифровых активов и связанных с ними рисков требует специальных знаний и опыта.
                Недостаток информации и/или компетенций может привести к принятию ошибочных решений
                и финансовым потерям.
              </li>
              <li class="mt-2">
                <strong>1.6. Киберриски.</strong>
                Цифровые активы и связанные с ними сервисы уязвимы к кибератакам, включая взлом,
                фишинг, потерю ключей, компрометацию учётных данных и иные технические уязвимости.
              </li>
              <li class="mt-2">
                <strong>1.7. Ограниченность механизма восстановления.</strong>
                Процедуры восстановления утраченных или похищенных цифровых активов ограничены
                либо отсутствуют, вследствие чего их возврат может быть невозможен.
              </li>
              <li class="mt-2">
                <strong>1.8. Необратимость транзакций.</strong>
                Транзакции в большинстве блокчейнов являются необратимыми: ошибочные,
                неправильно адресованные или мошеннические переводы, как правило,
                не подлежат возврату или отмене.
              </li>
              <li class="mt-2">
                <strong>1.9. Рыночные и поведенческие риски.</strong>
                Стоимость цифровых активов определяется спросом и предложением, а также поведением
                и ожиданиями участников рынка. Снижение спроса или изменение рыночных настроений
                может привести к существенному или полному обесценению цифровых активов.
              </li>
              <li class="mt-2">
                <strong>1.10. Технологические и эксплуатационные риски.</strong>
                Сбои оборудования, программного обеспечения, нарушения в работе интернет-соединения
                или систем третьих лиц могут привести к невозможности исполнить ордера, задержкам
                в их исполнении или некорректному отражению сделок, а также к финансовым потерям.
              </li>
              <li class="mt-2">
                <strong>1.11. Технологические обновления и изменения протоколов.</strong>
                Изменения протоколов (включая hard fork, airdrop и другие события) могут повлиять
                на доступность, функциональность или стоимость цифровых активов. Такие изменения
                также могут привести к приостановке операций на Платформе и/или к ограничению
                поддержки соответствующих активов.
              </li>
              <li class="mt-2">
                <strong>1.12. Риск делистинга.</strong>
                Отдельные цифровые активы могут быть исключены (делистинг) из обращения на Платформе
                по техническим, рыночным, регуляторным или иным причинам. Предварительное уведомление
                о делистинге может не предоставляться. Делистинг может повлечь ограничения на совершение
                операций с соответствующими активами, включая необходимость их вывода в установленные сроки.
              </li>
            </ul>
          </div>

          <!-- 2. Регуляторные и правовые риски -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M8 1a2 2 0 0 1 2 2h3.5a.5.5 0 0 1 .5.5V5H2V3.5a.5.5 0 0 1 .5-.5H6a2 2 0 0 1 2-2z"
                />
                <path
                  d="M2 6h12v6.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V6zm5.5 1v4h1V7h-1z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                2. Регуляторные и правовые риски
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>2.1. Изменение регулирования.</strong>
                Законодательство и регуляторные требования в отношении цифровых активов могут
                изменяться, а также по-разному применяться и толковаться регулирующими органами
                (включая AFSA и иные компетентные органы). Такие изменения могут ограничить или
                запретить отдельные операции, повлиять на стоимость цифровых активов, а также
                привести к приостановке или прекращению деятельности Платформы либо ограничению
                доступа к ней.
              </li>
              <li class="mt-2">
                <strong>2.2. Юрисдикционные различия.</strong>
                Операции с цифровыми активами в разных юрисдикциях могут регулироваться по-разному.
                Деятельность, разрешённая в одной юрисдикции, может быть ограничена или запрещена
                в другой. Пользователь обязан самостоятельно учитывать применимое к нему
                законодательство, а несоблюдение таких требований может привести к юридической
                ответственности или ограничению доступа к Платформе.
              </li>
              <li class="mt-2">
                <strong>2.3. Налоговые обязательства.</strong>
                Операции с цифровыми активами и полученные доходы могут подлежать налогообложению
                в соответствии с применимым законодательством. Налоговые правила могут быть сложными,
                неоднозначными и изменяться со временем. Пользователь несёт ответственность
                за определение, расчёт, декларирование и уплату применимых налогов и сборов.
              </li>
            </ul>
          </div>

          <!-- 3. Операционные и контрагентские риски -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M3 2a1 1 0 0 0-1 1v3h12V3a1 1 0 0 0-1-1H3zm-1 6v5a1 1 0 0 0 1 1h4V8H2zm6 0v6h4a1 1 0 0 0 1-1V8H8z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                3. Операционные и контрагентские риски
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>3.1. Риск поставщиков услуг и контрагентов.</strong>
                Частная компания «Digital Galaxy Ltd.» использует сторонних провайдеров ликвидности,
                кастодиальных провайдеров (Digital Wallet Service Providers), платёжных агрегаторов и др.
                Функционирование Платформы зависит от таких поставщиков. Их отказ, банкротство,
                технические проблемы или нарушение обязательств могут привести к задержкам,
                утрате цифровых активов или невозможности исполнения операций.
              </li>
              <li class="mt-2">
                <strong>3.2. Риски интеграции и API.</strong>
                Ошибки в интеграции с биржами, API-сервисы поставщиков или собственные технические
                сбои Платформы могут привести к некорректному исполнению ордеров
                или неверному отображению балансов.
              </li>
              <li class="mt-2">
                <strong>3.3. Ограничения доступа.</strong>
                Доступ к Платформе или отдельным её функциям может быть временно ограничен или
                приостановлен в связи с техническим обслуживанием, форс-мажором, требованиями
                регулятора или по причинам информационной безопасности или иным причинам.
                Такие ограничения могут вводиться без предварительного уведомления и приводить
                к невозможности совершения операций.
              </li>
              <li class="mt-2">
                <strong>3.4. Риск внешних транзакций и переводов.</strong>
                Переводы цифровых активов на внешние кошельки или адреса, не контролируемые Платформой,
                осуществляются на ваш страх и риск. Частная компания «Digital Galaxy Ltd.» не контролирует
                такие адреса и не гарантирует корректность указанных реквизитов. Ошибочные или неправильно
                адресованные переводы могут привести к утрате цифровых активов. Компания не несёт
                ответственности за ошибки или потери при таких транзакциях.
              </li>
            </ul>
          </div>

          <!-- 4. Риски, связанные с данными -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M8 1a4 4 0 0 0-4 4v2H3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1V5a4 4 0 0 0-4-4zM6 5a2 2 0 1 1 4 0v2H6V5z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                4. Риски, связанные с безопасностью данных и конфиденциальностью
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>4.1. Обработка персональных данных.</strong>
                При использовании Платформы Частная компания «Digital Galaxy Ltd.» собирает
                и обрабатывает персональные данные в соответствии с Политикой конфиденциальности.
                Пользователь осознаёт и принимает риск того, что несмотря на принимаемые меры защиты,
                возможны случаи утечки, утраты или несанкционированного доступа к персональным данным,
                что может повлечь за собой финансовые убытки или репутационный ущерб.
              </li>
              <li class="mt-2">
                <strong>4.2. Хранение и использование клиентских данных третьими лицами.</strong>
                В целях оказания услуг Частная компания «Digital Galaxy Ltd.» сотрудничает
                с поставщиками KYC/KYT и иными контрагентами. Пользователь соглашается с тем,
                что его данные могут передаваться таким третьим лицам и обрабатываться ими в пределах,
                необходимых для выполнения соответствующих функций, при условии соблюдения применимых
                требований законодательства о защите данных. Несмотря на это, передача данных третьим
                лицам может увеличивать риски их утечки или несанкционированного доступа.
              </li>
            </ul>
          </div>

          <!-- 5. Финансовые риски -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M2 2h12v3H2V2zm0 5h12v3H2V7zm0 5h12v2H2v-2z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                5. Финансовые риски
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>5.1. Риск запасов (inventory risk).</strong>
                Если Частная компания «Digital Galaxy Ltd.» держит резервы цифровых активов
                или фиатных средств, Пользователь осознаёт, что колебания обменных курсов
                между моментом приобретения и моментом реализации таких активов могут привести
                к финансовым потерям для компании. Это, в свою очередь, может повлиять на стоимость
                услуг или привести к изменению цен, применяемых к операциям Пользователя.
              </li>
              <li class="mt-2">
                <strong>5.2. Отсутствие гарантированной прибыли.</strong>
                Пользователь подтверждает, что Частная компания «Digital Galaxy Ltd.» не предоставляет
                каких-либо гарантий получения прибыли, доходности или сохранности инвестиций.
                Любые операции с цифровыми активами сопряжены с риском убытков, а прошлые финансовые
                показатели или результаты не являются надёжным индикатором будущей доходности.
              </li>
            </ul>
          </div>

          <!-- 6. Риски преступного характера и комплаенс -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M5.338 1.59a61 61 0 0 0-2.837.856A1 1 0 0 0 1 3.39V6c0 5.255 3.522 7.507 6.364 8.651a1 1 0 0 0 .272.06 1 1 0 0 0 .272-.06C10.75 13.507 14 11.255 14 6V3.39a1 1 0 0 0-.5-.864 61 61 0 0 0-2.838-.856c-.39-.12-.778-.24-1.158-.368a4 4 0 0 0-2.008 0c-.38.128-.768.248-1.158.368"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                6. Риски преступного характера и комплаенс
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>6.1. Риск отмывания денег и санкций.</strong>
                Пользователь осознаёт, что специфика цифровых активов повышает вероятность их
                использования в целях отмывания средств, финансирования терроризма и иных
                противоправных действий. Частная компания «Digital Galaxy Ltd.» применяет процедуры
                KYC/KYT, системы мониторинга операций и иные меры внутреннего контроля для выявления
                и предотвращения подобных операций. Вместе с тем указанные меры не обеспечивают полной
                защиты и не исключают вероятность вовлечения Платформы или Пользователя в противоправную
                деятельность третьих лиц.
              </li>
              <li class="mt-2">
                <strong>6.2. Блокировка и заморозка средств.</strong>
                Пользователь соглашается с тем, что в случае выявления подозрительной активности,
                наличия обоснованных подозрений в нарушении законодательства, условий Платформы либо
                по требованию уполномоченных органов, Частная компания «Digital Galaxy Ltd.» вправе
                приостановить операции, ограничить доступ к аккаунту, а также заморозить или заблокировать
                средства до выяснения обстоятельств.
              </li>
              <li class="mt-2">
                <strong>6.3. Ограничения доступа для санкционных лиц и юрисдикций.</strong>
                Пользователь подтверждает, что он не является резидентом или гражданином государств,
                находящихся под международными санкциями, и не включён в санкционные списки (включая,
                но не ограничиваясь, OFAC, ЕС, ООН, Великобритания и иные применимые списки).
                Частная компания «Digital Galaxy Ltd.» оставляет за собой право ограничить или прекратить
                предоставление услуг Пользователю в случае выявления его принадлежности к таким
                юрисдикциям или спискам.
              </li>
            </ul>
          </div>

          <!-- 7. Дополнительные риски пользователя -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M8 0a5 5 0 0 0-5 5v.278A2 2 0 0 0 2 7v5a2 2 0 0 0 2 2h2.5l.5 2 1-2H11a2 2 0 0 0 2-2V7a2 2 0 0 0-1-1.722V5a5 5 0 0 0-5-5z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                7. Дополнительные риски пользователя
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>7.1. Самостоятельные ошибки.</strong>
                Пользователь несёт полную ответственность за корректность указания реквизитов
                и параметров транзакции, включая адрес кошелька, выбор сети (например, ERC-20, BEP-20
                и иные), а также иные технические данные. Пользователь осознаёт, что ошибки при совершении
                операций могут привести к полной и необратимой утрате средств без возможности
                их восстановления.
              </li>
              <li class="mt-2">
                <strong>7.2. Недостаток страхования.</strong>
                Пользователь подтверждает, что в отношении операций с цифровыми активами, как правило,
                отсутствуют признанные и универсальные механизмы страхования или гарантированной
                компенсации убытков. В случае утраты средств по любой причине, включая технические сбои,
                ошибки Пользователя или действия третьих лиц, такие убытки могут не подлежать возмещению.
              </li>
              <li class="mt-2">
                <strong>7.3. Ограничения на использование в будущем.</strong>
                Пользователь осознаёт, что принятие цифровых активов в качестве средства расчёта
                не гарантировано в будущем. Контрагенты, торговые площадки или иные третьи лица могут
                в любой момент отказаться от их использования или ограничить операции с ними,
                что может повлиять на ликвидность и возможность использования таких активов.
              </li>
            </ul>
          </div>

          <!-- 8. Force majeure -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M4.5 3a1 1 0 0 1 .832-.555L9.6 2.01a1 1 0 0 1 1.027.64l1.8 4.8a1 1 0 0 1-.26 1.08l-6.4 5.8A1 1 0 0 1 4 13.8V3.5a1 1 0 0 1 .5-.866z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                8. Force majeure и технологические приостановки
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>8.1. Форс-мажор.</strong>
                Частная компания «Digital Galaxy Ltd.» не несёт ответственность за полное или частичное
                неисполнение обязательств, вызванное обстоятельствами непреодолимой силы, находящимися
                вне разумного контроля Сторон, включая, но не ограничиваясь: военные действия, стихийные
                бедствия, массовые кибератаки, эмбарго, решения государственных органов и регуляторов,
                отключение или сбои в работе телекоммуникационных и энергетических систем. Указанные
                обстоятельства могут привести к временной или полной приостановке работы Платформы
                либо невозможности выполнения операций.
              </li>
              <li class="mt-2">
                <strong>8.2. Техническое обслуживание.</strong>
                Частная компания «Digital Galaxy Ltd.» вправе ограничивать доступ к Платформе полностью
                или частично в целях проведения технического обслуживания, обновления программного
                обеспечения или устранения неисправностей. Компания принимает разумные меры
                для минимизации возможных неудобств для Пользователей и, по возможности, осуществляет
                предварительное уведомление о таких работах.
              </li>
            </ul>
          </div>

          <!-- 9. Налоговые обязательства -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M1 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 .8.4l1.1 1.467A1 1 0 0 0 8.2 5.8L9 5h6v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                9. Налоговые обязательства
              </h5>
            </div>
            <p class="mb-0">
              Пользователи обязаны самостоятельно исполнять налоговые обязательства, возникшие
              в связи с использованием Платформы и совершением операций с цифровыми активами,
              в соответствии с применимым законодательством. Частная компания «Digital Galaxy Ltd.»
              не оказывает налоговых консультаций, не выступает налоговым агентом и не несёт
              ответственности за определение, расчёт или уплату налогов Пользователями.
            </p>
          </div>

          <!-- 10. Ответственность и ограничения -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zM7 4.5h2V9H7V4.5zm1 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                10. Ответственность и ограничения
              </h5>
            </div>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li>
                <strong>10.1. Ограничение ответственности.</strong>
                Частная компания «Digital Galaxy Ltd.» не предоставляет гарантий отсутствия убытков,
                стабильности доходности или бесперебойной работы Платформы и не несёт ответственности
                за любые косвенные, случайные, последующие убытки, упущенную выгоду, потерю данных
                или иные убытки, не подлежащие возмещению в соответствии с применимым законодательством,
                за исключением случаев, прямо предусмотренных пользовательским соглашением
                или действующим законодательством.
              </li>
              <li class="mt-2">
                <strong>10.2. Рекомендация.</strong>
                Перед началом использования Платформы и совершением операций с цифровыми активами
                Пользователь обязан самостоятельно оценить свои финансовые возможности, инвестиционные
                цели и допустимый уровень риска. При необходимости Пользователю рекомендуется обратиться
                за консультацией к независимым финансовым, юридическим или налоговым специалистам.
              </li>
            </ul>
          </div>

          <!-- 11. Контакты -->
          <div class="mt-4">
            <div class="d-flex align-items-center mb-2" style="gap:.6rem;">
              <!-- icon -->
              <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true">
                <path
                  d="M3.654 1.328a.678.678 0 0 1 .738-.057l2.522 1.26a.678.678 0 0 1 .346.77l-.7 2.803a.678.678 0 0 1-.588.51c-.26.026-.51.08-.747.16a8.385 8.385 0 0 0 3.1 3.1c.08-.238.134-.487.16-.747a.678.678 0 0 1 .51-.588l2.803-.7a.678.678 0 0 1 .77.346l1.26 2.522a.678.678 0 0 1-.057.738l-1.247 1.55c-.215.268-.54.43-.884.43C6.728 15.5 1.5 10.272 1.5 3.781c0-.344.162-.669.43-.884l1.724-1.569z"
                />
              </svg>
              <h5 class="text-white-50 text-uppercase fw-semibold mb-0" style="letter-spacing:.5px;">
                11. Контакты и дополнительные сведения
              </h5>
            </div>
            <p>
              По всем вопросам, связанным с рисками, безопасностью, обработкой персональных данных
              и соблюдением требований регулятора, Пользователь может обращаться в службу поддержки
              или в отдел комплаенса Частной компании «Digital Galaxy Ltd.» по официальным каналам
              связи, указанным на Платформе или в соответствующем разделе документации.
            </p>
            <p>
              Компания рассматривает обращения в разумные сроки в соответствии с внутренними
              процедурами и применимыми требованиями законодательства. Указанные сроки могут
              различаться в зависимости от характера запроса и его сложности.
            </p>
            <p class="mb-2">Обращения рассматриваются через следующие официальные каналы связи:</p>
            <ul class="mb-0 ps-3" style="line-height:1.55;">
              <li><strong>Эл. почта:</strong> support@payton.kz</li>
              <li>
                <strong>Адрес:</strong> Республика Казахстан, г. Астана, ул. Туркестан,
                дом 8/2, н.п. 11, офис 1104
              </li>
            </ul>
          </div>

          <!-- Conclusion -->
          <div class="mt-4 pt-3 border-top" style="border-color: rgba(255,255,255,.15) !important;">
            <p class="mb-0 text-white-50">
              Пользовательское участие в операциях с цифровыми активами связано
              с существенными рисками. Частная компания <strong>«Digital Galaxy Ltd.»</strong>
              стремится обеспечивать прозрачность, безопасность и соответствие законодательству,
              однако не может исключить всех возможных рисков, присущих цифровым активам
              и сопутствующим технологиям, включая технические сбои, рыночную волатильность,
              действия третьих лиц и иные непредвиденные обстоятельства.
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-col>
</b-row>

</template>

<script>
    
    import axios from 'axios';
    import {mapActions,mapState} from 'vuex';
    export default {
        name: "About",
        data(){
            return {
                svgWidth: 150,
                svgHeight: 30,
                coinData: [],
                items: [
                    { title: "Как это работает?", content: "Здесь будет текстовое описание", active: false },
                    { title: "Как я могу торговать криптовалютой?", content: "Здесь будет текстовое описание", active: false },
                ]
            }
        },
        methods:{
            changeRoute(routeName){
                this.$router.push('/'+routeName)
            },
            async fetchBitcoinPriceData(ids) {
                const endpoint = 'https://api.coingecko.com/api/v3/coins/markets?x_cg_demo_api_key=CG-UhwnpGqWNHeMipRrQ8Wr5Yxr';
                const params = {
                    vs_currency: 'usd',
                    days: 0, // Fetch 7 days of data
                    interval: 'daily',
                    ids:ids,
                    order: 'market_cap_desc', // Order by market capitalization
                    per_page: 2, // Number of coins per page
                    page: 1, // Page number
                    sparkline: true // Disable sparkline
                };

                try {
                    const response = await axios.get(endpoint, {
                        params: params,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CoinGecko-Api-Key': 'CG-UhwnpGqWNHeMipRrQ8Wr5Yxr'
                        }
                    });
                    
                    console.log('Bitcoin price data:', response.data);
                    
                
                    // Truncate sparkline_in_7d to include only the last 7 days
                    const coinData = response.data.map(coin => {
                        const sparklineData = coin.sparkline_in_7d.price.slice(-7); // Get the last 7 days
                        return { ...coin, sparkline_in_7d: sparklineData };
                    });

                    
                    this.coinData = this.coinData.concat(coinData);
                    
                } catch (error) {
                    console.error('Error fetching Bitcoin price data:', error);
                }
            },
            generatePath(priceData, index) {
                const dataLength = priceData.length;
                const priceMax = Math.max(...priceData);
                const priceMin = Math.min(...priceData);
                const priceRange = priceMax - priceMin;
                const xStep = this.svgWidth / (dataLength - 1);

                let path = `M0 ${this.svgHeight - ((priceData[0] - priceMin) / priceRange) * this.svgHeight}`;
                for (let i = 1; i < dataLength; i++) {
                    const x = i * xStep;
                    const y = this.svgHeight - ((priceData[i] - priceMin) / priceRange) * this.svgHeight;
                    path += ` L${x} ${y}`;
                }

                return path;
            },
            toggleAccordion(index) {
                this.items[index].active = !this.items[index].active;
            },
            hasRole(roleName){
                if(this.loginedUser && this.loginedUser.userRoles){
                    let roleNames = this.loginedUser.userRoles;
                    if(roleNames.length>0){
                    //alert(JSON.stringify(roleNames));
                    for(let r=0;r<roleNames.length;r++){
                        
                        if(roleNames[r].name===roleName){
                        return true;
                        }
                    }
                    }
                    else{
                    return false;
                    }
                }
                return false;
                
                
            }
        },
        mounted(){
            this.fetchBitcoinPriceData( 'bitcoin,ethereum');
      
            this.fetchBitcoinPriceData( 'tether,binancecoin');
        },
        computed:{
            ...mapState([
                'loginedUser'
            ]),
        }
        
    }   
</script>
<style>
    .copyright{        
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .main-bottom-top{
        height: 1px;
        background: var(--Neutrals-2, #23262F);
    }
    .no-style-input{
        appearance: none;
        background-color: transparent;
        border: none;
        outline: none;
        font-family: inherit;
        font-size: inherit;
        color: inherit;
        line-height: inherit;
        padding: 0;
        margin: 0;
    }
    .sub-container{
        border-radius: 16px;
        border: 2px solid var(--Neutrals-6, #E6E8EC);
    }
    .footer-addr{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .footer-link{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .accordion-item{
        cursor: pointer;
    }
    .accordion-item-answer{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .accordion-item-question{
        cursor: pointer;
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .accordion-item {
        width: 100%;
        max-width: 546px;
        margin: 0 auto;
        border-bottom:1px solid var(--Neutrals-3, #353945);
        
    }
    .service-btn-container{
        cursor: pointer;
        border-radius: 12px;
        background: var(--Primary-1, #EFB914);
    }
    .service-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .service-item-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .service-item-name{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .service-item{
        border-radius: 20px;
        background: var(--Neutrals-1, #141416);
    }
    .service-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .no-style {
        color: inherit; /* Inherit color from parent */
        text-decoration: none; /* Remove underline */
    }
    .news-item-desc{
        
        color: var(--Neutrals-4, #777E90);
        overflow: visible; 
        white-space: normal; 
        text-overflow: clip;
        /* Caption */
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 171.429% */
    }
    .news-item-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .main-news-desc{
        overflow: hidden;
        color: var(--Neutrals-4, #777E90);
        text-overflow: ellipsis;
        white-space: pre-wrap;
        height: auto;
        /* Body 2 */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
    }
    .main-news-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px; /* 125% */
        letter-spacing: -0.96px;
    }
    .trade-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .trade-btn{
        cursor: pointer;
        border-radius: 8px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .list-text-percentage{
        color: var(--Primary-4, #58BD7D);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-price{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; 
    }
    .list-sep{
        height: 1px;
        border-radius: 2px;
        background: var(--Neutrals-3, #353945);
    }
    .list-text-code{
        color: var(--Neutrals-5, #B1B5C3);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-crypto{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-number{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-header-text{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .tab-btn:hover{
        cursor: pointer;
        border-radius: 8px;
        background: var(--Neutrals-3, #353945);
    }
    .tab-btn:hover .tab-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
    }
    .tab-btn-text{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .more-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .more-btn-container{
        cursor: pointer;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .clist-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 56px;
        letter-spacing: -0.96px;
    }
    .main-sep{
        height: 1px;
        background: #B1B5C3;
    }
    .crypto-cost-current{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
    }
    .crypto-cost-prev{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .crypto-percentage{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        border-radius: 24px;
        background: var(--Primary-3, #FF6838);
    }
    .crypto-name{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }
    .crypto-item:hover{
        cursor: pointer;
        border-radius: 16px;
        background: var(--Neutrals-3, #353945);
        box-shadow: 0px 64px 64px -48px rgba(15, 15, 15, 0.10);
    }
    .banner-crypto-container{
        border-radius: 24px;
        background: var(--Neutrals-2, #23262F);
    }
    .banner-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 64px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        letter-spacing: -1.28px;
    }
    .banner-desc{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .crypto-btn{
        border-radius: 12px;
        border: 2px solid var(--Neutrals-4, #777E90);
    }
    .crypto-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: right;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
</style>

